import React from 'react'

export const ClearFilledIcon: React.FC<{ color?: string; fill?: string; size?: number }> = ({
  color = '#474747',
  fill = '#F0E977',
  size = 18,
}) => (
  <svg width={size} height={size} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='9' cy='9' r='9' fill={fill} />
    <path
      d='M13.167 5.80571L12.3613 5L9.16699 8.19429L5.97271 5L5.16699 5.80571L8.36128 9L5.16699 12.1943L5.97271 13L9.16699 9.80571L12.3613 13L13.167 12.1943L9.97271 9L13.167 5.80571Z'
      fill={color}
    />
  </svg>
)
